export default __webpack_public_path__ + "static/media/Diana e Mauro Covacich.6bfd1bd9.jpg";